"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataInterfaces_1 = require("../Types/DataInterfaces");
var ProtobufferAndExternalNameConversion_1 = require("./ProtobufferAndExternalNameConversion");
var DataPoint = /** @class */ (function () {
    function DataPoint(oId, qId, tStep, percentile, value) {
        if (qId && qId.split('|')[0] === "TOTALRETURN") {
            //NONE OF THIS CODE IS RELIABLE.  CONSIDER IT BROKEN UNTIL TESTED!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            var _a = qId.split('|'), TOTALRETURN = _a[0], strategy = _a[1];
            if (strategy === "DefaultInvestmentFund") {
                this.name = "DefaultInvestmentFund";
            }
            else {
                this.name = strategy;
            } //TODO set default investment fund to the asset allocation which needs to be input into this function now maybe?  Or convert it at a later step
            this.name = this.name.toUpperCase();
            this.displayName = ProtobufferAndExternalNameConversion_1.PToE(false)(this.name);
            this.portfolioOrigin = DataInterfaces_1.PortfolioContext.Undef;
            this.id = qId;
            this.timestep = tStep;
            this.metric = "Graph";
            this.percentile = percentile || 0;
            this.value = value || 0;
            this.isWhatIf = false;
            this.age = 0;
            //^^^^^^^^^^^NONE OF THIS CODE IS RELIABLE.  CONSIDER IT BROKEN UNTIL TESTED!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        }
        else {
            //Data is for the matrix or backtest
            var _b = oId.split('|'), whatIf = _b[0], risk = _b[1], strategy = _b[2], withEk = _b[3], metric = _b[4], age = _b[5];
            var isSS = withEk.toUpperCase() === "WITHEK";
            if (risk) {
                this.name = risk;
                this.portfolioOrigin = isSS ? DataInterfaces_1.PortfolioContext.SS : DataInterfaces_1.PortfolioContext.Equiv;
            }
            else if (strategy) {
                this.name = strategy;
                this.portfolioOrigin = DataInterfaces_1.PortfolioContext.Chosen;
            }
            else {
                this.name = "UnDef";
                this.portfolioOrigin = DataInterfaces_1.PortfolioContext.Undef;
            }
            this.displayName = ProtobufferAndExternalNameConversion_1.PToE(isSS)(this.name);
            this.id = oId;
            this.timestep = tStep || 0;
            this.metric = metric;
            this.percentile = percentile || 0;
            this.value = value || 0;
            this.isWhatIf = whatIf ? true : false;
            this.age = parseInt(age.replace(/Age/i, ""), 10);
        }
    }
    return DataPoint;
}());
exports.default = DataPoint;
//# sourceMappingURL=DataPoint.js.map